const black = {
  dark: '#27272a',
  base: '#333333',
};

const gray = {
  dark: '#696F6F',
  base: '#9B9B9B',
  light: '#e5e5e5',
  lighter: '#f7f7f9',
};

const blue = '#3c93ce';

const orange = '#f5a623';

const mint = {
  dark: '#2dbaad',
  base: '#00d0bd',
  light: '#4ce7d9',
};

const red = '#f55753';

export default {
  primary: blue,
  accent: mint.base,
  warning: orange,
  error: red,
  text: {
    primary: black.base,
    secondary: gray.base,
    title: gray.dark,
    price: red,
    error: red,
    info: blue,
    positive: mint.base,
    negative: red,
    disabled: gray.light,
    accent: blue,
  },
  border: gray.light,
  background: {
    dark: black.base,
    light: gray.lighter,
  },
  calculator: {
    button: mint.base,
    buttonActive: mint.dark,
    border: mint.light,
  },
  brand: {
    line: '#00c300',
  },
};



// WEBPACK FOOTER //
// ../pos-master/packages/pos-helper/src/color.js